<script>export let active = false;
</script>

{#if active}
	<svg
		width="24"
		height="24"
		style="fill:currentColor"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M17.54 8.81a2.96 2.96 0 1 0 0-5.92 2.96 2.96 0 0 0 0 5.92m-11.08 0a2.96 2.96 0 1 0 0-5.92 2.96 2.96 0 0 0 0 5.92m11.08 12.3a2.96 2.96 0 1 0 0-5.92 2.96 2.96 0 0 0 0 5.92m-11.08 0a2.96 2.96 0 1 0 0-5.92 2.96 2.96 0 0 0 0 5.92"
		/>
	</svg>
{:else}
	<svg
		width="24"
		height="24"
		style="fill:currentColor"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2m-.83 12.3c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2.3-2.3-2.3 2.3c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06l2.3-2.3-2.3-2.3a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.3 2.3 2.3-2.3c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-2.3 2.3z"
		/>
	</svg>
{/if}

<style>
</style>
